import { useSyncExternalStore } from "react";
import newTokenService from "../services/newTokenService";

/**
 * Estado "vendo como" lido do claim `impersonatorId` do JWT — fonte autoritativa
 * (não sessionStorage), e agora REATIVO.
 *
 * O access token só vive em memória: no reload a página monta sem token e só o
 * ganha quando o `/auth/refresh` volta. Lendo no corpo do render, quem montasse
 * antes disso ficava com a leitura velha e a personificação virava silenciosa —
 * sem banner e sem "Voltar à minha sessão" (G14, spec 004). `useSyncExternalStore`
 * re-renderiza quando o token chega.
 */
export function useImpersonatorId(): number | null {
  return useSyncExternalStore(
    newTokenService.subscribe,
    () => newTokenService.getImpersonatorId(),
    () => null,
  );
}

export function useIsImpersonating(): boolean {
  return useImpersonatorId() !== null;
}
